/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Input, Row, Col, Card} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import './invoice.css';
import {
    getProductList3,
    getDetail1,
    setProductUp,
    setProductUp2,
    getProductCategory,
    confirmReceive
} from '../../service/invoiceManagement';
import {Store, Actions} from './store';

class InvoiceDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        // console.log(this.props.params)
        // debugger
        let isSpecial = this.props.params.tag == 'Special' ? true : false;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.state = {
            opts: ['开票明细'],
            detailData: {},
            id: this.props.params.invoiceManagementId,
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                startDate: d.format('yyyy-MM-dd'),
                endDate: d.format('yyyy-MM-dd'),
                s: 10,
                p: 1
            },
            // categoryData: [],
            button_limits_end: {},
            loading: true,
            tablePage: {
                p: 1,
                s: 10
            },
            isSpecial
        };
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.nextChange = this.nextChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    /*返回*/
    backHandle() {
        window.history.go(-1);
    }

    /*编辑*/
    editHandle() {
        if (!this.state.isSpecial) {
            this.goView({
                pathname: 'invoiceManagement/normalInvoice',
                state: {
                    type: 'edit',
                    id: this.state.id
                }
            });
        } else {
            this.goView({
                pathname: 'invoiceManagement/specialInvoice',
                state: {
                    type: 'edit',
                    id: this.state.id
                }
            });
        }
    }

    /*选择*/
    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    };

    /*筛选*/
    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    /*确认签收*/
    confirmHandle() {
        let self = this;
        // const { detailData } = this.state;
        // let ids = [];
        // ids.push(detailData.id);
        // let params = {
        // 	'ids': ids
        // };
        // console.log(this.state.id);
        // return;
        confirmReceive(self.state.id).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '确认签收成功', '');
                this.backHandle();
                // self.setState({
                // 	'detailData': {
                // 		...self.state.detailData,
                // 	}
                // });
            } else {
                openNotice('error', '确认签收失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*移除暂存*/
    removeChange() {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        setProductUp(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '移除成功', '');
                self.initData();
            } else {
                openNotice('error', '移除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*下一步*/
    nextChange() {
        alert("下一步")
    };


    goView(url) {
        hashHistory.push(url);
    };

    /*重置*/
    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                name: '',
                category: [],
                active: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        // this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
        this.setState({tablePage: {s: pageSize, p: page}}, function () {
            self.initData();
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        self.setState({
            loading: true
        })
        getProductList3(self.state.id, this.state.tablePage.p, this.state.tablePage.s).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
        getDetail1(self.state.id).then(function (result) {
            if (result && result.code == 200) {
                // console.log(result)
                // debugger
                if (result.data) {
                    var data = result.data;
                    self.setState({
                        'orderNumberList': data.orderNumber,
                        'invoiceNumberList': data.invoiceNumber,
                        'totalAmountList': data.totalAmount,
                        'invoiceCodeList': data.invoiceCode,
                        'statusList': data.statusTxt,
                        'signStatus': data.status,	// 确认签收显示按钮
                        'amountList': data.amount,
                        'orderCreatedDateList': data.orderCreatedDate,
                        'discountRateList': data.discountRate,
                        'taxAmountList': data.taxAmount,
                        'remarkList': data.remark,
                        'addressPhoneList': data.addressPhone,
                        'discountList': data.discount,
                        'weiSalesUnitList': data.weiSalesUnit,
                        'bankList': data.bank,
                        'taxpayersList': data.taxpayers,
                        'salesUnitList': data.salesUnit,
                        'customerNameList': data.customerName,
                        'addressList': data.address,
                        'courierNumberList': data.courierNumber,
                        'gouxiaoUomList': data.gouxiaoUom,
                        'salesChannelCodeList': data.salesChannel,
                        'newSalesUnit': data.newSalesUnit,
                        'specialBillingType': data.specialBillingType,
                        'saleInvoiceBank': data.saleInvoiceBank,
                        detailData: result.data,
                    });
                }
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        // getProductCategory().then(function (categoryResult) {
        // 	/* 产品分类 */
        // 	if (!categoryResult || categoryResult.code != 200) {
        // 		openNotice('error', '产品分类数据获取失败，请重试', '');
        // 		return;
        // 	}
        // 	self.setState({
        // 		categoryData: categoryResult.data || []
        // 	});
        // });
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /*导出*/
    exportChange() {
        let id = this.state.id;
        let url = `${config.server}/api/v1/dms/tzOrderSync/exportInvoiceDetail?id=${id}`;
        window.open(url);
    };


    render() {
        const {
            detailData,
            button_limits_end,
            opts,
            key,
            rows,
            total,
            searchObj,
            orderNumberList,
            invoiceNumberList,
            totalAmountList,
            invoiceCodeList,
            statusList,
            amountList,
            orderCreatedDateList,
            discountRateList,
            taxAmountList,
            remarkList,
            addressPhoneList,
            discountList,
            weiSalesUnitList,
            bankList,
            taxpayersList,
            salesUnitList,
            customerNameList,
            addressList,
            courierNumberList,
            gouxiaoUomList,
            salesChannelCodeList,
            newSalesUnit,
            specialBillingType,
            loading,
            isSpecial,
            signStatus,
            saleInvoiceBank
        } = this.state;
        let columns = [
            {
                title: '物料编码',
                dataIndex: 'itemNum'
            },
            {
                title: '物料描述',
                dataIndex: 'itemDesc',
                width: 200
            }
        ]
        if (isSpecial) {
            columns.push(
                {
                    title: '物料描述调整',
                    dataIndex: 'adjustDesc'
                },
                {
                    title: '物料类别调整',
                    dataIndex: 'newDescCategories'
                },
                {
                    title: '单位调整',
                    dataIndex: 'adjustUnit'
                }
            );
        }
        columns.push(
            {
                title: '物料类别',
                dataIndex: 'itemCategory'
            },
            {
                title: '单位',
                dataIndex: 'unit'
            },
            {
                title: '数量',
                dataIndex: 'qty'
            },
            {
                title: '单价(元)',
                dataIndex: 'sellingPrice'
            },
            {
                title: '金额',
                dataIndex: 'amount'
            },
            {
                title: '税码',
                dataIndex: 'taxCode'
            },
            {
                title: '总金额',
                dataIndex: 'totalAmount'
            },
            {
                title: '备注',
                dataIndex: 'remark'
            },
            {
                title: '发票池ID',
                dataIndex: 'lineId'
            }
        );
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.tablePage.p,//当前页码
                pageSize: this.state.tablePage.s,//当前分页数
                onChange: this.pageChange
            },
            columns,
            rows,
        };
        return <div>
            <div className="companyTitle">
                <h1>{salesUnitList}</h1>
                {/*{
					button_limits_end.invoiceManagement_detail_01 
					&& 
					signStatus != 'R' 
					&& 
					courierNumberList 
					&&  
					<Button className="specialInvoice" onClick={this.confirmHandle.bind(this)}>确认签收</Button>
				}*/}
                {statusList == '保存'
                    &&
                    <Button className="edit" key="edit" onClick={this.editHandle.bind(this)}
                            style={{position: 'absolute', bottom: '15px', right: '170px'}}>编辑</Button>
                }
                <Button style={{position: 'absolute', bottom: 15, right: 100}}
                        onClick={this.backHandle.bind(this)}>返回</Button>
                <Button style={{position: 'absolute', bottom: 15, right: 12}} icon="export"
                        onClick={this.exportChange}>导出</Button>
                {/* <Button style={{position: 'absolute', bottom: 190, right: 15}} icon="export"
                            onClick={this.exportChange}>导出</Button>*/}

            </div>
            <div className="dms-table-box" style={{padding: 0, position: 'relative'}}>
                <Row>
                    <Col span={8}>
                        <Card bordered={false} noHovering={true}>
                            <p><label>订单编号:</label><span>{orderNumberList}</span></p>
                            {/*<p><label>增值税发票代码:</label><span>{invoiceCodeList}</span></p>*/}
                            <p><label>开票日期:</label><span>{orderCreatedDateList}</span></p>
                            <p><label>备注:</label><span>{remarkList}</span></p>
                            <p><label>未结购货单位:</label><span>{weiSalesUnitList}</span></p>
                            <p><label>纳税人识别号:</label><span>{taxpayersList}</span></p>
                            <p><label>客户名称:</label><span>{customerNameList}</span></p>
                            <p><label>购销单位:</label><span>{gouxiaoUomList}</span></p>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card bordered={false} noHovering={true}>
                            <p><label>增值税发票号码:</label><span>{invoiceNumberList}</span></p>
                            <p><label>状态:</label><span>{statusList}</span></p>
                            <p><label>折扣比例:</label><span>{discountRateList}</span></p>
                            <p><label>地址、电话:</label><span>{addressPhoneList}</span></p>
                            <p><label>开户行及银行卡号:</label><span>{bankList}</span></p>
                            <p><label>开单购货单位:</label><span>{salesUnitList}</span></p>
                            {isSpecial && <p><label>新购货单位:</label><span>{newSalesUnit}</span></p>}
                            <p><label>销方银行:</label><span>{saleInvoiceBank}</span></p>
                            <p><label>邮寄地址:</label><span>{addressList}</span></p>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card bordered={false} noHovering={true}>
                            <p><label>总金额:</label><span>{totalAmountList}</span></p>
                            <p><label>金额合计:</label><span>{amountList}</span></p>
                            <p><label>税额合计:</label><span>{taxAmountList}</span></p>
                            <p><label>折扣合计:</label><span>{discountList}</span></p>
                            <p><label>快递公司:</label><span>{detailData.expCompany || '-'}</span></p>
                            <p><label>邮寄日期:</label><span>{detailData.printDate || '-'}</span></p>
                            <p><label>邮寄联系电话:</label><span>{detailData.phone || '-'}</span></p>
                            <p><label>快递单号</label><span>{detailData.courierNumber || '-'}</span></p>
                            {isSpecial && <p><label>修改类型:</label><span>{specialBillingType}</span></p>}
                        </Card>
                    </Col>
                </Row>
            </div>

            <div className="dms-table-box">

                <DmsTab className="dms-table-title" options={opts} defaultKey={key}></DmsTab>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(InvoiceDetail);


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/detail.js